import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

export function getDmUsage(params) {
  return request({
    url: `${v2Host}/dashboard/project/dm-usages`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function getUsage(params) {
  return request({
    url: `${v2Host}/dashboard/project/usages`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function getOptionList(params) {
  return request({
    url: `${v2Host}/dashboard/project/option-list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}
